import React, {useEffect, useState} from 'react'
import classes from './UnAuthenticatedJob.module.css'
import {Link, useParams, useHistory} from 'react-router-dom'
import {FiBriefcase, FiClock} from 'react-icons/fi'
import {Button} from '../../components/Button/Button'
import {serverConn} from "../../API/apiRequest";
import TimeAgo from "javascript-time-ago";
import {ToastContainer, toast} from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';
import {Loading} from "../../components/Loading/Loading";

interface Props {
}

export const UnAuthenticatedJob: React.FC<Props> = () => {
    const timeAgo = new TimeAgo('ar-EG')
    let Params: any = useParams()
    let history = useHistory();
    const [Load, setLoad] = useState<boolean>(true);
    const [JopData, setJopData] = useState<{
        id: string,
        advantages: Array<string>, age: string,
        companyId: string,
        canApply: boolean,
        companyImage: string,
        companyName: string,
        createdAt: string,
        description: string,
        edu: string,
        employeeNumber: number,
        exp: string,
        field: string,
        gender: string,
        requireCV: boolean,
        hasApplication: boolean,
        requirements: Array<string>,
        questions: Array<string>,
        salary: string,
        specialty: string,
        title: string,
        type: string,
    }>();
    const HandleSaveJop = () => {
        toast.error("يجب تسجيل الدخول");
        history.push('/login')
        sessionStorage.setItem("url", `/employee/job/${Params.id}`);
    }
    const handleSubmit = () => {
        toast.error("يجب تسجيل الدخول");
        history.push('/login');
        sessionStorage.setItem("url", `/employee/job/${Params.id}`);
    }
    useEffect(() => {
        setLoad(true)
        window.scrollTo(0, 0)
        serverConn.get(`/jobs/${Params.id}`).then((res) => {
            if(res.status === 200) {
                setJopData(res.data.job);
                setLoad(false)
            }
        }).catch(err =>{
            return history.replace('/404')
        })
    }, [Params.id, history]);
    return (
            <React.Fragment>

                <div className={classes.page}>
                    {!Load && JopData ? (
                            <div className={"animate__animated animate__fadeIn  " + classes.container}>
                                <ToastContainer
                                        closeOnClick={false}
                                        autoClose={3000}
                                        pauseOnHover
                                        newestOnTop
                                        hideProgressBar={false}

                                        position="bottom-right" rtl/>
                                <div className={classes.all}>
                                    <div className={classes.secondJobSection}>
                                        <div className={classes.headSecond}>
                                            <p>تفاصيل الوظيفة</p>
                                        </div>
                                        <div dir="rtl" style={{color: '#fff'}} className={classes.description}>
                                            {JopData.description}
                                        </div>
                                        {JopData.requirements.length > 0 ? (
                                                <>
                                                    <div className={classes.headSecond}>
                                                        <p>المتطلبات</p>
                                                    </div>
                                                    <div dir="rtl">
                                                        <ul style={{color: 'white'}}>
                                                            {JopData.requirements.map((req, index) => {
                                                                return (
                                                                        <li key={index}>{req}</li>
                                                                );
                                                            })}


                                                        </ul>
                                                    </div>
                                                </>
                                        ) : ""}

                                        {JopData.advantages.length > 0 ? (<>
                                            <div className={classes.headSecond}>
                                                <p>المميزات</p>
                                            </div>
                                            <div dir="rtl">
                                                <ul style={{color: 'white'}}>
                                                    {JopData.advantages.map((adv, index) => {
                                                        return (
                                                                <li key={index}>{adv}</li>
                                                        );
                                                    })}


                                                </ul>
                                            </div>
                                        </>) : ""}
                                    </div>

                                    <div className={classes.info}>
                                        <Link to={`/company/${JopData.companyId}`}
                                              className={"my-2 " + classes.company}>
                                            <div className={classes.companyName}>
                                                <p>{JopData.companyName}</p>
                                            </div>
                                            <img src={JopData.companyImage}
                                                 onError={({currentTarget}) => {
                                                     currentTarget.onerror = null; // prevents looping
                                                     currentTarget.src = "../../assets/icons/NoCompany.svg";
                                                 }}
                                                 className={classes.image} alt={JopData.companyName}/>
                                        </Link>

                                        <div className={classes.firstJobSection}>
                                            <div className={classes.head}>
                                                <div onClick={() => HandleSaveJop()} className={classes.IconSave}>

                                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1"

                                                         width="25" height="25" x="0" y="0"
                                                         viewBox="0 0 511.958 511.958"
                                                         className="">
                                                        <g>
                                                            <path xmlns="http://www.w3.org/2000/svg"
                                                                  d="m400.579 0h-289.2c-25.487 0-47.133 20.556-47.133 47.133v427.63c.075 33.733 41.277 49.561 64.701 25.882l110.235-110.204c8.834-9.216 24.76-9.216 33.594 0l110.235 110.204c23.434 23.688 64.631 7.836 64.701-25.882v-427.63c0-26.577-21.646-47.133-47.133-47.133zm17.133 474.764c-.037 7.142-8.915 9.499-13.508 4.649-22.037-22.071-84.882-84.897-110.195-110.164-19.913-20.826-56.117-20.832-76.021-.04-17.486 17.453-51.714 51.671-78.696 78.645l-31.39 31.376c-4.523 4.799-13.512 3.197-13.657-4.194v-427.903c0-9.582 7.767-17.133 17.134-17.133h289.199c9.353 0 17.134 7.539 17.134 17.133z"
                                                                  data-original="#000000" fill="white"
                                                                  className=""></path>
                                                        </g>
                                                    </svg>
                                                </div>
                                                <div className={classes.title}>
                                                    <p>{JopData.title}</p>
                                                </div>
                                                <FiBriefcase className={classes.headIcon} size={40} color='#BBBBBB'/>
                                            </div>
                                            <div className={classes.item}>
                                                <p> {(timeAgo.format(Date.now() - (Date.now() - new Date(JopData.createdAt).getTime()))).toString()}</p>
                                                <FiClock size={22} color='#BBBBBB'/>
                                            </div>
                                            <div className={classes.item}>
                                                <p style={{marginTop: 15}}>{JopData.employeeNumber}</p>
                                                <p style={{...styleText, marginTop: 15}}>:عدد العمالة</p>
                                            </div>
                                            <div className={classes.item}>
                                                <p>{JopData.exp}</p>
                                                <p style={styleText}>:الخبرة</p>
                                            </div>
                                            <div className={classes.item}>
                                                <p>{JopData.edu}</p>
                                                <p style={styleText}>:التعليم</p>
                                            </div>
                                            <div className={classes.item}>
                                                <p>{JopData.age} - {JopData.gender} </p>
                                                <p style={styleText}>:السن والنوع</p>
                                            </div>
                                            <div className={classes.item}>
                                                <p>{JopData.salary}</p>
                                                <p style={styleText}>:الراتب</p>
                                            </div>
                                            <div className={classes.item}>
                                                <p>{JopData.type}</p>
                                                <p style={styleText}>:وقت العمل</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {!JopData.canApply && JopData.hasApplication ? (
                                        <div className={'d-flex justify-content-center '}>
                                            <p className={classes.TextNote}>لقد قدمت علي هذه الوظيفة من قبل</p>
                                        </div>) : JopData.canApply && !JopData.hasApplication ? (
                                        <div style={{alignSelf: 'center', marginTop: "10px"}}>
                                            <Button
                                                    onPress={() => handleSubmit()}
                                                    width={250}
                                                    fontSize={17}
                                                    height={60}
                                                    color='#6EB66C'>التقديم علي الوظيفة</Button>
                                        </div>
                                ) : ""}

                            </div>
                    ) : <div className={'loadingfull'}><Loading/></div>}


                </div>
            </React.Fragment>
    )
}
const styleText = {
    color: '#BBBBBB',
    margin: 0,
    padding: 0
}